$(document).ready(() => {
    validateDownloadResource();

    $('#not-practice-download').on('click', function () {
        $(this).siblings('p').show();
    });
});

function validateDownloadResource(){
    $('a.download-resource').on('click', function (e){
        var agreeTerms = $('#checkbox-terms');
        if ($('#checkbox-terms').is(":checked")) {
            e.preventDefault();
            $('.download-error').show();
        } else{
            $.ajax({
                url: origin + '/practice/download-resource-data',
                type: 'post',
                contentType: false,
                processData: false,
                dataType: 'json'
            });
            $('.download-error').hide();
        }
    });
}


